
<template>
  <div>
    <NewPayment kind="deposit" @close="$router.push({ name: 'OpenDeposits' })"></NewPayment>
  </div>
</template>

<script>

export default {
  name: 'NewDeposit',
  components: {
    NewPayment: () => import('@/_backoffice/_financial/components/order_payment/NewPayment.vue'),
  },
}
</script>
